// analytics tools
import { identify, Identify, track, init, getDeviceId } from '@amplitude/marketing-analytics-browser'
import { isObject } from '../../helpers/object'
import config from './config.json'

/**
 * Initialize ZOHO
 * If the deviceId isn't provided with the init like,
 * then it automatically fallbacks to use URL parameter.
 * @param deviceId
 * @param userId
 * @param pageViewTracking
 */
export const initAmplitude = (deviceId = null, userId = null, pageViewTracking = true) => {
  const env = import.meta.env.VITE_APP_ENV
  setUserProperty('source', 'wp', null)
  setUserProperty('environment', env || '')
  init(config.apiKey,
    userId,
    {
      pageViewTracking,
      deviceId
    }
  ).promise.then(() => {
    window.$amplitudeDeviceId = getDeviceId()
    window.$amplitudeTrack = track
  })
}

/** Track amplitude with GTM */
export const trackAmplitudeEvent = (eventName, eventProps, callback = null) => {
  const deviceId = window.$amplitudeDeviceId
  if (!deviceId) {
    console.warn('trackAmplitudeEvent deviceId processing...')
    setTimeout(() => { trackAmplitudeEvent(eventName, eventProps, callback) }, 1000)
  } else {
    const hasProps = isObject(eventProps) && (Object.keys(eventProps).length > 0)
    if (!hasProps) {
      window.$amplitudeTrack(eventName).promise
        .then(() => { if (callback) { callback() } })
        .catch(() => { if (callback) { callback() } })

      // GTM
      window.dataLayer.push({ event: eventName })
    } else {
      window.$amplitudeTrack(eventName, eventProps).promise
        .then(() => { if (callback) { callback() } })
        .catch(() => { if (callback) { callback() } })
      // GTM
      window.dataLayer.push({
        event: eventName,
        event_params: { ...eventProps }
      })
    }
  }
}

export const setUserProperty = (name, value, identifyObj = null, once = false) => {
  const method = once ? 'setOnce' : 'set'
  if (!identifyObj) {
    const identifySetOnceObj = new Identify()
    identifySetOnceObj[method](name, value)
    identify(identifySetOnceObj)
  } else {
    identifyObj[method](name, value)
  }
}

export const setUserPropertiesFromQuery = () => {
  const identifyObj = new Identify()
  const searchParams = new URLSearchParams(window.location.search)
  const paramsObj = Array.from(searchParams.keys()).reduce(
    (acc, val) => ({ ...acc, [val]: searchParams.get(val) }),
    {}
  )
  const paramsKeys = Object.keys(paramsObj)
  if (paramsKeys.length > 0) {
    paramsKeys.forEach(param => {
      const query = paramsObj[param]
      setUserProperty(`initial_${param}`, query, identifyObj, true)
      setUserProperty(param, query, identifyObj, false)
    })
    identify(identifyObj)
  }
}
